'use strict'

module.exports = {
    autoHighlight: require('./auto_highlight'),
    getCrop: require('./get_image_crop_rect'),
    hasDims: require('./has_dimensions'),
    hasHighlight: require('./has_highlight'),
    getImageHighlightPosition: require('./highlight_position'),
    getImgixUrl: require('./imgix'),
    getCloudflareUrl: require('./cloudflare'),
}
